/**
 * 쿠폰 번역 중 현재 locale에 맞는 이름 추출
 * fallback: locale → ko → en → 첫 번째 → fallbackName
 */
export function getLocalizedCouponName(
  translations: { lang_code: string; name: string }[] | undefined | null,
  locale: string,
  fallbackName: string,
): string {
  if (!translations?.length) return fallbackName;

  const exact = translations.find((t) => t.lang_code === locale);
  if (exact?.name) return exact.name;

  const ko = translations.find((t) => t.lang_code === "ko");
  if (ko?.name) return ko.name;

  const en = translations.find((t) => t.lang_code === "en");
  if (en?.name) return en.name;

  return translations[0]?.name || fallbackName;
}
